import styled from "@emotion/styled";

import Button from "components/ui/button/Button";
import Badge from "lib/core_components/Badge";
import { Flex } from "../../../styles/utility-components";

import css from "./FilterFormTitle.module.scss";

export interface FilterFormTitleProps {
  onClose: () => void;
  clearFilters?: () => void;
  showClear?: boolean;
  isSidebar?: boolean;
  isEmptyState?: boolean;
  filtersCount?: number;
  onSideBarOpenChange?: (open: boolean) => void;
  hideSidebarCollapseButton?: boolean;
}

function ClearAllButton({
  showClear,
  clearFilters,
}: {
  showClear?: boolean;
  clearFilters?: () => void;
}) {
  if (!showClear || !clearFilters) return null;

  return (
    <Button buttonType="tertiary" onClick={clearFilters}>
      Clear all
    </Button>
  );
}

function FilterFormTitle({
  clearFilters,
  onClose,
  showClear,
  isSidebar,
  isEmptyState,
  filtersCount,
  onSideBarOpenChange,
  hideSidebarCollapseButton = false,
}: FilterFormTitleProps) {
  if (!isSidebar && isEmptyState) {
    return null;
  }

  return (
    <>
      {isSidebar && (
        <FilterHeaderContainer>
          <Flex alignItems="center" gap={8}>
            <FilterHeader>Filters</FilterHeader>
            <StyledBadge size={18}>{filtersCount}</StyledBadge>
            <ClearAllButton showClear={showClear} clearFilters={clearFilters} />
          </Flex>

          {!hideSidebarCollapseButton && (filtersCount ?? 0) > 0 ? (
            <Button
              buttonType="secondary"
              icon="chevronLeftDouble"
              className={css.icon}
              onClick={() => {
                onSideBarOpenChange?.(false);
              }}
              aria-label="Close filters"
            />
          ) : null}
        </FilterHeaderContainer>
      )}

      {!isSidebar && (
        <div className={css.wrapper}>
          <div className={css.titleContainer}>
            <Flex alignItems="flexStart" gap={16}>
              <Button
                buttonType="secondary"
                icon="chevronRightDouble"
                className={css.icon}
                onClick={() => onClose()}
                aria-label="Close filters"
              />
              <h3 className={css.title}>Filters</h3>
            </Flex>
          </div>
          <div className={css.buttonWrapper}>
            <ClearAllButton showClear={showClear} clearFilters={clearFilters} />
          </div>
        </div>
      )}
    </>
  );
}

export default FilterFormTitle;

const FilterHeaderContainer = styled(Flex)(({ theme }) => ({
  alignItems: "center",
  gap: 8,
  justifyContent: "space-between",
  padding: "16px 24px",
  borderBottom: `1px solid ${theme.colors.sysBorderDecorative}`,
  height: "64px",
}));

const StyledBadge = styled(Badge)({
  marginLeft: 0,
});

const FilterHeader = styled.div(({ theme }) => ({
  color: theme.colors.sysTextDefault,
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: "125%",
}));
